import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { GamificationService } from '../services/gamification.service';
import { GamificationResultHandler } from './gamification-result.handler';

@Component({
  selector: 'sym-gamification-result',
  templateUrl: './gamification-result.component.html',
  styleUrls: ['./gamification-result.component.scss'],
})
export class GamificationResultComponent extends GamificationResultHandler {
  constructor(
    public service: GamificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
